$(function () {
    $("#loginEmail, #userEmail, #remail, #remail2, #email1, #forgotPassword_email, #email-tracking-order-id").on("keyup", function (ev) {
        var emailEl = this
        var emailLowerCase = emailEl.value.toLowerCase()
        emailEl.value = emailLowerCase
    })
})
